import { Tags } from '@ppvrbh/merchant-frontend-core';
import { CAT_STATE_KEY, CatState } from './cat-reducer';
import { MenuCategoryData } from '../interface';
import { MenuInCatType } from '../../../../shared/models/food-menu';

export enum CAT_ACTION_TYPE {
  SET_CAT_STATE = 'SET_CAT_STATE',
  SET_CATEGORY_SEQUENCE = 'SET_CATEGORY_SEQUENCE',
  CALL_FOOD_CATEGORY = 'CALL_FOOD_CATEGORY',
  CALL_FULL_FOOD_CATEGORY = 'CALL_FULL_FOOD_CATEGORY',
  CALL_MENU_IN_CAT = 'CALL_MENU_IN_CAT',
  SORT_MENU_SEQUENCE = 'SORT_MENU_SEQUENCE',
}

export type SetCatStateAction<KeyName extends keyof CatState> = {
  type: CAT_ACTION_TYPE.SET_CAT_STATE;
  payload: { key: KeyName, value: CatState[KeyName] };
};

export type CallFoodCategoryAction = {
  type: CAT_ACTION_TYPE.CALL_FOOD_CATEGORY;
  payload: { onFailureCallback: () => void, isAddCategoryPage: boolean, onSuccessCallback?: (tagMaster: Tags[]) => void, options?: {menuCount?: boolean, menuCategoryCount?: boolean, keyword?: string, page?:number, limit?:number} };
};

export type CallFullFoodCategoryAction = {
  type: CAT_ACTION_TYPE.CALL_FULL_FOOD_CATEGORY;
  payload: { onSuccessCallback: (menuCategories: MenuCategoryData[]) => void };
};

export type UpdateCategorySequence = {
  type: CAT_ACTION_TYPE.SET_CATEGORY_SEQUENCE,
  payload: { categorieyIds: number[]}
}


export type CallMenuInCatAction = {
  type: CAT_ACTION_TYPE.CALL_MENU_IN_CAT;
  payload: {
    onFailureCallback: () => void;
    foodCategoryId: string;
    onSuccessCallback?: (menuInCat: MenuInCatType) => void;
    search?: string;
    page?: number;
    limit?: number;
  };
};


export type SortMenuSequenceAction = {
  type: CAT_ACTION_TYPE.SORT_MENU_SEQUENCE;
  payload: {
    menuCategoryId: number;
    menuIds: number[];
    onSuccessCallback?: () => void;
    onFailureCallback?: () => void;
  };
};

export type CatActions = SetCatStateAction<CAT_STATE_KEY> | CallFoodCategoryAction | CallFullFoodCategoryAction | CallMenuInCatAction | SortMenuSequenceAction;
